(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-country-selector')) {
		customElements.define(
			'cv-country-selector',
			class extends HTMLElement {
				connectedCallback() {
					this.abort = new AbortController();

					this.addEventListener(
						'click',
						(event) => {
							if (event.target.closest('.cv-country-selector__trigger')) {
								this.toggle();
							} else if (
								event.target.classList.contains('cv-country-selector__backdrop')
							) {
								this.close();
							}
						},
						{ signal: this.abort.signal }
					);
				}

				disconnectedCallback() {
					this.abort.abort();
				}

				get trigger() {
					return this.querySelector('.cv-country-selector__trigger');
				}

				get popover() {
					return this.querySelector('.cv-country-selector__popover');
				}

				toggle() {
					if (this.popover.hidden) {
						this.open();
					} else {
						this.close();
					}
				}

				open() {
					this.popover.hidden = false;
					this.trigger.setAttribute('aria-expanded', 'true');
				}

				close() {
					this.popover.hidden = true;
					this.trigger.setAttribute('aria-expanded', 'false');
				}
			}
		);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-icon-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-icon-cart')) {
		customElements.define(
			'cv-icon-cart',
			class extends HTMLElement {
				connectedCallback() {
					this.abort = new AbortController();
					this.badge = this.querySelector('.cv-icon-cart__count');
					if (!this.badge) return;

					this.lastCount = parseInt(this.badge.textContent, 10) || 0;

					document.addEventListener(
						'rebuy:cart.change',
						(event) => {
							const count = event.detail.cart.itemCount();
							this.badge.textContent =
								count > 99 ? '99+'
								: count > 0 ? count
								: '';
							if (count !== this.lastCount) this.bump();
							this.lastCount = count;
						},
						{ signal: this.abort.signal }
					);

					this.addEventListener('animationend', () => {
						this.classList.remove('cv-icon-cart--bump');
					});
				}

				disconnectedCallback() {
					this.abort.abort();
				}

				bump() {
					this.classList.remove('cv-icon-cart--bump');
					requestAnimationFrame(() => {
						this.classList.add('cv-icon-cart--bump');
					});
				}
			}
		);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-read-more"] && !Shopify.designMode) return;
  try {
    class CvReadMore extends HTMLElement {
		connectedCallback() {
			this.content = this.querySelector('.cv-read-more__content');
			this.toggle = this.querySelector('.cv-read-more__toggle');
			if (!this.content || !this.toggle) return;

			this.toggle.addEventListener('click', () => this.expand());

			this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
			this.resizeObserver.observe(this.content);

			if (document.fonts?.ready) {
				document.fonts.ready.then(() => this.checkOverflow());
			}
		}

		disconnectedCallback() {
			this.resizeObserver?.disconnect();
		}

		checkOverflow() {
			if (this.hasAttribute('data-expanded')) return;
			const overflowing =
				this.content.scrollHeight > this.content.clientHeight + 1;
			this.toggleAttribute('data-overflowing', overflowing);
		}

		expand() {
			this.setAttribute('data-expanded', '');
			this.toggle.setAttribute('aria-expanded', 'true');
		}
	}

	if (!customElements.get('cv-read-more')) {
		customElements.define('cv-read-more', CvReadMore);
	}
  } catch(e) { console.error(e); }
})();

})();
